import { render, staticRenderFns } from "./inspectionFinishForm.vue?vue&type=template&id=5b2b922a&scoped=true"
import script from "./inspectionFinishForm.vue?vue&type=script&lang=js"
export * from "./inspectionFinishForm.vue?vue&type=script&lang=js"
import style0 from "./inspectionFinishForm.vue?vue&type=style&index=0&id=5b2b922a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b922a",
  null
  
)

export default component.exports